var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlower(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 283,
    viewBox: "0 0 282 283",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "8u8oqyw2ja"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440 0v988H0V0h1440z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o2ht4jbcnb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282 0v282.138H0V0h282z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "teab6itorc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.506 0c0 52.271-41.422 94.656-92.506 94.656C0 42.386 41.422 0 92.506 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5g3sbp1rvd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.595 0c14.144 0 25.623 11.764 25.623 26.26l-.205 1.996c4.202-2.941 9.122-4.622 14.554-4.622 14.144 0 25.623 11.764 25.623 26.26 0 10.504-6.047 19.432-14.656 23.634 8.609 4.201 14.656 13.13 14.656 23.634 0 14.495-11.48 26.26-25.623 26.26-5.432 0-10.454-1.681-14.554-4.622l.205 1.996c0 14.495-11.48 26.26-25.623 26.26-14.144 0-25.623-11.765-25.623-26.26l.205-1.996c-4.202 2.941-9.122 4.622-14.554 4.622C11.479 123.422 0 111.657 0 97.162c0-10.504 6.047-19.433 14.656-23.634C6.047 69.326 0 60.398 0 49.894c0-14.496 11.48-26.26 25.623-26.26 5.432 0 10.454 1.68 14.554 4.622l-.205-1.996C39.972 11.764 51.452 0 65.595 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "63hc70w3ue"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.07 0c14.39 0 26.07 11.737 26.07 26.2 0 14.462-11.68 26.2-26.07 26.2S0 40.661 0 26.2C0 11.737 11.68 0 26.07 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bfqapkvzwf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c51.084 0 92.506 42.385 92.506 94.656C41.422 94.656 0 52.271 0 0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8u8oqyw2ja)",
    transform: "translate(-579 -242)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o2ht4jbcnb)",
    transform: "translate(579 242)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h282v282.138H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#teab6itorc)",
    transform: "translate(721.497 396.6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#30CA4D",
    d: "M0 0h92.506v94.656H0V0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M721.497 491.256c51.083 0 92.505-42.385 92.505-94.657-51.083 0-92.505 42.385-92.505 94.657z",
    stroke: "#000",
    strokeWidth: 2.565,
    fill: "none",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5g3sbp1rvd)",
    transform: "translate(655.902 271.518)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#30CA4D",
    d: "M0 0h131.19v147.056H0V0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M655.902 368.68c0 14.495 11.479 26.26 25.623 26.26 5.432 0 10.351-1.681 14.554-4.623l-.205 1.996c0 14.496 11.479 26.26 25.623 26.26 14.144 0 25.623-11.764 25.623-26.26l-.205-1.996c4.1 2.942 9.122 4.622 14.554 4.622 14.144 0 25.623-11.764 25.623-26.26 0-10.504-6.047-19.432-14.657-23.634 8.61-4.201 14.657-13.13 14.657-23.634 0-14.495-11.48-26.26-25.623-26.26-5.432 0-10.352 1.681-14.554 4.622l.205-1.996c0-14.495-11.48-26.26-25.623-26.26-14.144 0-25.623 11.765-25.623 26.26l.205 1.996c-4.1-2.94-9.122-4.622-14.554-4.622-14.144 0-25.623 11.765-25.623 26.26 0 10.504 6.047 19.433 14.656 23.634-8.61 4.202-14.656 13.13-14.656 23.634z",
    stroke: "#000",
    strokeWidth: 2.565,
    fill: "none",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#63hc70w3ue)",
    transform: "translate(696.268 318.846)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h52.14v52.4H0V0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M722.338 318.846c14.39 0 26.07 11.737 26.07 26.2 0 14.461-11.68 26.199-26.07 26.199s-26.07-11.738-26.07-26.2 11.68-26.2 26.07-26.2z",
    stroke: "#000",
    strokeWidth: 2.565,
    fill: "none",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bfqapkvzwf)",
    transform: "translate(628.99 396.6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#30CA4D",
    d: "M0 0h92.506v94.656H0V0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M628.99 396.6c0 52.27 41.423 94.656 92.507 94.656 0-52.272-41.422-94.657-92.506-94.657z",
    stroke: "#000",
    strokeWidth: 2.565,
    fill: "none",
    strokeMiterlimit: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower);
export default __webpack_public_path__ + "static/media/flower.ea44b8c44405c6aca5bba464a6afc36c.svg";
export { ForwardRef as ReactComponent };